import React, { useEffect, createElement } from 'react';
import { LulutoxLanding } from './pages/LulutoxLanding';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  useEffect(() => {
    // Tracking script
    const trackingScript = document.createElement('script');
    trackingScript.type = 'text/javascript';
    trackingScript.src = 'https://trk.gohealthboost.com/track.js?rtkcmpid=697b6d65f2da9c2769b29f90';
    document.head.appendChild(trackingScript);
    return () => {
      document.head.removeChild(trackingScript);
    };
  }, []);
  return <>
      <FacebookPixel data-id="element-0" />
      <LulutoxLanding data-id="element-1" />
    </>;
}